module.exports = __webpack_public_path__ + "img/c7a498d.svg";